import React, { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
// hooks
import { useSelector } from 'react-redux';
// pages
import Login from '../pages/auth/Login';

// ----------------------------------------------------------------------

interface AuthGuardProps {
  children: React.ReactNode,
}

export default function AuthGuard({ children }: AuthGuardProps) {
  const { user } = useSelector((state: any) => state.user )
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState<string | null>(null);

  if (!user || !Object.keys(user).length) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Login />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
}
